import {makeAutoObservable} from "mobx";

class UserStore {

    userId = null;
    refreshing= false;
    refreshSubscribers: Array<(token: string) => void> = [];
    userAccessToken = null;
    partnerId = null;
    langCode = '';
    userPlanData = null;
    userActivePlanData = null;
    servers_ping = null;
    settingWindow = false
    userConfigs = null
    can_activate_trial = null
    is_trial_activated = false
    telegramId = null;
    banner_index = 0;
    passVpnOffer = null;
    isUserClosePassVpnOffer = false;
    offerId = null
    coinCount = null
    countryCode = null
    ref_code = null
    is_referral = null
    shareMsgId = null

    visual_effects = {
        anim_bg: JSON.parse(localStorage.getItem("anim_bg")) === null
            ? (() => {
                localStorage.setItem("anim_bg", JSON.stringify(true));
                return true;
            })()
            : JSON.parse(localStorage.getItem("anim_bg"))
    };


    constructor() {
        makeAutoObservable(this)
    }

    setCountryCode(countryCode) {
        this.countryCode = countryCode;
    }

    subscribeTokenRefresh(callback: (token: string) => void) {
        this.refreshSubscribers.push(callback);
    }

    onRefreshed(newToken: string) {
        this.refreshSubscribers.forEach(callback => callback(newToken));
        this.refreshSubscribers = [];
    }

    setUserData(userData, accessToken) {
        this.userAccessToken = accessToken;
        this.can_activate_trial = userData.can_activate_trial;
        this.is_trial_activated = userData.is_trial_activated;
        this.offerId = userData.special_offer_id;
        this.ref_code = userData.ref_code
        this.is_referral = userData.is_referral
    }
    setUserAccessToken(accessToken) {
        this.userAccessToken = accessToken
    }

    setCoinCount(count) {
        this.coinCount = count;
    }
    setOfferId(offerId) {
        this.offerId = offerId;
    }

    setVisualEffectsAnimBg() {
        this.visual_effects.anim_bg = !this.visual_effects.anim_bg;
        localStorage.setItem("anim_bg", JSON.stringify(this.visual_effects.anim_bg)); // Сохраняем как строку JSON
    }
    setPassVpnOffer(state) {
        this.passVpnOffer = state
    }

    closePassOffer () {
        this.isUserClosePassVpnOffer = true;
    }

    setTelegramId(telegramId) {
        this.telegramId = telegramId;
    }

    setBannerIndex(index) {
        this.banner_index = index;
    }

    setGovnoBannerIndex(index) {
        this.govno_banner_index = index;
    }
    incrementBannerIndex(bannerLength) {
        this.banner_index = (this.banner_index + 1) % bannerLength; // например, у нас 3 баннера
    }

    setUserConfigs(configs) {
        this.userConfigs = {...this.userConfigs, ...configs}
    }

    incrementConfig(indexActiveServer, protocolId, data) {
        this.userConfigs.server_id[indexActiveServer][protocolId]['config_text'] = data
    }

    setSettingWindow(state) {
        this.settingWindow = state;
    }
    setUserId(id) {
        this.userId = id;
    }

    setLangCode(langCode) {
        if (langCode === 'en-US') {
            this.langCode = 'en';
            localStorage.setItem('lang_code', 'en')
            return
        }
        else this.langCode = langCode
        localStorage.setItem('lang_code', langCode)
    }

    setPartner(partnerId) {
        this.partnerId = partnerId;
    }

    setUserPlanData(planData) {
        if (planData) {
            this.userPlanData = planData;
            const active_plans = planData.filter(el => el.status);
            if (active_plans.length > 0) this.userActivePlanData = active_plans;
        } else {
            this.userPlanData = null;
        }
    }

    setPlanDataAfterPayment(planData) {
        if (planData) {
            if (this.userActivePlanData) {
                this.userActivePlanData = [...this.userActivePlanData, planData]
            } else  {
                this.userActivePlanData = planData
            }

        }
    }

    setServersPing(data) {
        this.servers_ping = {
            ...data
        }
    }
    setIsTrailActivated(state) {
        this.can_activate_trial = state
    }
    setTrailActivated(state) {
        this.is_trial_activated = state
    }
    
    setShareMsgId(msgId) {
        this.shareMsgId = msgId;
    }
}

export default new UserStore();